import React from 'react';
import { useTranslation } from 'react-i18next';

import { useGetBulkSigningLinkLazyQuery } from '../../../app/generated/graphql';
import Button from '../../../app/components/Button';
import utils from '../../../app/domain/utils';

const BulkSigningButton = () => {
  const { t } = useTranslation();
  const [getBulkLink, { loading }] = useGetBulkSigningLinkLazyQuery();
  const [canBulkSign, setCanBulkSign] = React.useState<boolean>(true);

  const noContractToSign = t('contractsPage.noContractToSign');

  return (
    <div className="pb-3 d-flex justify-content-end">
      <Button
        trackingEvent="m.contract.button.bulk.click"
        variant="primary"
        title={t('actions.bulk')}
        disabled={loading || !canBulkSign}
        onClick={
        () => getBulkLink()
          .then(({ data }) => {
            if (data && data.me?.bulkSigningLink) {
              utils.openLinkInNewWindow(data.me.bulkSigningLink);
            } else {
              setCanBulkSign(false);
              // eslint-disable-next-line no-alert
              alert(noContractToSign);
            }
          })
      }
      />
    </div>
  );
};

export default BulkSigningButton;
